import axios from "axios";

class PICService {

    async getPiani() {

        const response = await axios.get(
            "/api/welfareapi/get_piani_welfare/"
        );

        const rows = this.mapApiPiani(
            response.data.results
        );

        return this.buildTree(rows);
    }

    async getMacrocategorie(anno){
        return axios.get(
            "/api/welfareapi/get_macrocategorie/",
            {
                params: {
                    anno
                }
            }
        );
    }

    async getHeaderDashboard() {
        return axios.get(
            "/api/welfareapi/get_header_dashboard_pic/"
        );
    }

    async getDettaglioPiano(idPiano) {
        return axios.get(
            "/api/welfareapi/get_dettaglio_piano_pic/",
            {
                params: {
                    id_piano: idPiano
                }
            }
        );
    }

    buildTree(rows) {

    const map = {};
    const roots = [];

    // Crea la mappa di tutti i piani
    rows.forEach(row => {

        map[row.id] = {
            ...row,
            parent: null,
            children: []
        };
    });

    // Collega i figli ai rispettivi padri
    rows.forEach(row => {

        if (row.id_piano_padre !== null) {

            const padre = map[row.id_piano_padre];

            if (padre) {
                map[row.id].parent = padre;
                padre.children.push(
                    map[row.id]
                );
            }
        } else {
            roots.push(
                map[row.id]
            );
        }
    });
    
    return roots;
    }

    mapApiPiani(results) {
        // Converte i campi restituiti dall'API nella struttura utilizzata dai componenti PIC.
        return results.map(row => ({

            id: row.wpw_id,
            id_piano_padre: row.wpw_id_piano_padre,
            nome: row.wpw_descrizione,
            decorrenza: row.wpw_data_decorrenza,
            scadenza: row.wpw_data_scadenza
        }));
    }
}

export default new PICService();